import gql from "graphql-tag";

const GET_9142B_FORM_DATA = gql`
  query getForm9142BById($id: String!) {
    getForm9142BById(id: $id) {
      formVersionId
      payload {
        linkingIsNetwork
        linkingAcknowledgedDate
        linkingAcknowledgedBy
        formVersionId
        _blsCounties
        pwdDeterminationDate
        pwdDateSubmitted
        isEmergency
        emergencyJustification
        pwdLinking
        capSubject
        capExempt
        tempneedJobtitle
        tempneedSoc
        tempneedSocTitle
        tempneedWkrPos
        tempneedStart
        tempneedEnd
        tempneedNature
        tempneedDescription
        tempneedDoc
        empBusinessName
        empTradeName
        empAddr1
        empAddr2
        empCity
        empState
        empPostcode
        empCountry
        empProvince
        empPhone
        empPhoneext
        empFein
        empNaics
        empNaicsDescription
        emppocLastname
        emppocFirstname
        emppocMiddlename
        emppocJobtitle
        emppocAddr1
        emppocAddr2
        emppocCity
        emppocState
        emppocPostcode
        emppocCountry
        emppocProvince
        emppocPhone
        emppocPhoneext
        emppocEmail
        attyRepresentType
        attyLastname
        attyFirstname
        attyMiddlename
        attyAddr1
        attyAddr2
        attyCity
        attyState
        attyPostcode
        attyCountry
        attyProvince
        attyPhone
        attyPhoneext
        attyEmail
        attyBizname
        attyFein
        attyStatebarno
        attyStatehighct
        attyNamehighct
        attyIsAgreementAttached
        agntMspaAttached
        e21a_is_mspa_uploaded
        swaJoborderAttached
        swaJoborderStatename
        swaJoborderSubmitted
        jobDuties
        jobDutiesAttached
        jobHoursTotal
        jobHoursSun
        jobHoursMon
        jobHoursTues
        jobHoursWed
        jobHoursThu
        jobHoursFri
        jobHoursSat
        jobHourStart
        jobHourEnd
        jobMinedu
        jobMintrainingmonths
        jobMinexpmonths
        jobSupervisor
        jobNumberSup
        jobMinspecialreq
        jobAddr1
        jobAddr2
        jobCity
        jobState
        jobPostcode
        jobCounty {
          label
          value
        }
        jobMsa
        wageFrom
        wageTo
        wageOtFrom
        wageOtTo
        wageOtAvailable
        wagePer
        wageAdditional
        jobPwdNumber1
        jobPwdNumber2
        jobPwdNumber3
        appIsH2bPwdAttached
        jobMultiplesites
        empJoinApdxAAttached
        recIsDailyTransport
        recIsOtAvailable
        recIsTrainingAvailable
        recIsToolsEquip
        recIsLodging
        recPayDeductions
        recApplyPhone
        recApplyEmail
        recApplyUrl
        empType
        empMspaAttached
        g2_mspa_attached
        empclntApdxDAttached
        externalOtherDocPreface
        empIsContractAttached
        empflrecEngageH2b
        empflrecEngageH2bAttached
        empflrecApdxCAttached
        declareIsConfmApdxB
        declareConfmEmp
        prepLastname
        prepFirstname
        prepMiddlename
        prepFein
        prepBizname
        prepEmail
        employmentLocationWorksites {
          pwdWageRate
          pwdUnitOfPay
          worksiteCity
          worksiteState
          worksiteBlsArea
          worksiteCountyTownship
          determinationDate
          dateSubmitted
          rowNum
        }
        employmentLocations {
          determined_wage
          determined_wage_per
          apdxaCity
          apdxaState
          apdxaCounty {
            label
            value
          }
          apdxaMsa
          apdxaAddlInfo
          apdxaCrewId
          apdxaTotalWorkers
          apdxaBeginDate
          apdxaEndDate
          apdxaWageFrom
          apdxaWageTo
          apdxaWagePer
          _bls_counties
          meta_case_submit_date
          meta_case_determined_date
          sort_order
          id
          rowNum
        }
        appx_a_information_required
        recruiters {
          apdxcRecCity
          apdxcRecCountry
          apdxcRecFirstname
          apdxcRecMiddlename
          apdxcRecLastname
          apdxcRecOrg
          apdxcRecState
          apdxcRecPostcode
          apdxcRecProvince
          sort_order
          error
        }
        apdxdLegalName
        apdxdTradeName
        apdxdEmpAddr1
        apdxdEmpAddr2
        apdxdEmpCity
        apdxdEmpState
        apdxdEmpPostcode
        apdxdEmpCountry
        apdxdEmpProvince
        apdxdEmpPhone
        apdxdEmpPhoneext
        apdxdEmpFein
        apdxdEmpNaics
        apdxdEmpNaicsDescription
        apdxdPocLastname
        apdxdPocFirstname
        apdxdPocMiddlename
        apdxdPocJobtitle
        apdxdPocAddr1
        apdxdPocAddr2
        apdxdPocCity
        apdxdPocState
        apdxdPocPostcode
        apdxdPocCountry
        apdxdPocProvince
        apdxdPocPhone
        apdxdPocPhoneext
        apdxdPocEmail
        isRegistrationNumberLinked
        registrationNumber
        _9141_meta_case_status
        _9141_f4_prevailing_wage
        _9141_f5_wage_per

        files {
          machine_name
          application_id
          FileType
          fileType
          document_name
          size
          displayName
          lastModified
          state
          percentage
          document_path
        }
      }
      form_ui {
        pages_visited
        pages_errors
      }
    }
  }
`;

const SUBMIT_9142B_FORM = gql`
  mutation SubmitForm9142B(
    $id: String!
    $Form9142BFormData: Form9142BFormData!
    $token: String
  ) {
    SubmitForm9142B(
      Form9142BFormData: $Form9142BFormData
      id: $id
      token: $token
    )
  }
`;

const UPDATE_9142B_FORM = gql`
  mutation updateForm9142BById(
    $id: String!
    $Form9142BFormData: Form9142BFormData!
    $formUI9142B: formUIInput
    $profilePrefillMetadata: [ProfilePrefillMetadataInput!]
  ) {
    updateForm9142BById(
      id: $id
      Form9142BFormData: $Form9142BFormData
      formUI9142B: $formUI9142B
      profilePrefillMetadata: $profilePrefillMetadata
    )
  }
`;

const GET_9142B_PROFILES = gql`
  query {
    getUserProfileInfo {
      EmployerProfiles {
        employer_id
        employer_name
      }
      EmployerPOCProfiles {
        employer_poc_id
        employer_poc_name
      }
      AgentProfiles {
        agent_id
        agent_name
      }
      AgentIndividualProfiles {
        agent_ind_id
        agent_ind_name
      }
      RecruiterProfiles {
        recruiter_id
        recruiter_name
        first_name
        last_name
        employer_name
        city
        state
        country
      }
    }
  }
`;

export {
  GET_9142B_FORM_DATA,
  UPDATE_9142B_FORM,
  SUBMIT_9142B_FORM,
  GET_9142B_PROFILES,
};
